enum SanitizeDialogFields {
	PAGERANGE = "pagerange",
	ANNOTATIONS = "annotations",
	ATTACHMENTS = "attachments",
	FORMS = "forms",
	LAYERS = "layers",
	METADATA = "metadata",
	OUTLINES = "outlines",
	TAGS = "tags",
	PAGES = "pages",
	DPI = "dpi",
	ACTIONS = "actions"
}

export default SanitizeDialogFields;